module.exports = "/images/ad.svg?6765039c9ac6b51f9736489e6273cec2";